/* eslint-disable camelcase */
import axios from 'axios'
import { wmSign, wmAes, wm_aes_for_web } from '../../apiFunction/encrypt'
import { GetTimeStamp } from '../../apiFunction/getDate'

const appURL = `${process.env.REACT_APP_APP_URL}/api`
const appId = process.env.REACT_APP_ID
const deviceUuid = process.env.REACT_APP_DEVICE_UUID

const header = {
  'Content-Type': 'application/json',
  'Accept-Language': 'zh-TW',
  'app-id': appId,
  'device-uuid': deviceUuid
}

async function GetResetPassword (req) {
  const body = {
    temp_access_token: req.tempAccessToken,
    request_parameter: {
      new_password: wmAes(req.passwordVerify)
    },
    timestamp: GetTimeStamp()
  }
  const sign = wmSign(body)
  const data = {
    sign: sign
  }
  const response = await axios.post(`${appURL}/member/reset_password`, data, { headers: header })
  return response.data
}

async function GetResetPasswordAuthorize () {
  const memberAccessToken = sessionStorage.getItem('TEMP_ACCESS_TOKEN')
  const rurl = sessionStorage.getItem('rurl')
  const xToken = encodeURIComponent(wm_aes_for_web(memberAccessToken))
  const finalUrl = rurl + `&x_token=${xToken}`
  const authorizeHeader = { ...header, accept: 'application/json', 'X-MMRM-TOKEN': wmAes(memberAccessToken) }
  const response = await axios.get(`${finalUrl}`, { headers: authorizeHeader })
  return response.data
}

export { GetResetPassword, GetResetPasswordAuthorize }
